import FormattedMessage from 'I18n/components/FormattedMessage';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
function createAlert({
  message,
  options,
  title,
  type
}) {
  FloatingAlertStore.addAlert(Object.assign({
    message,
    titleText: title,
    type
  }, options));
}
export function alertSuccess({
  message,
  options,
  title
}) {
  createAlert({
    title: title || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.alerts.success.title"
    }),
    message,
    options,
    type: 'success'
  });
}
export function alertFailure({
  message,
  options,
  title
}) {
  createAlert({
    message: message || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.alerts.failure.message"
    }),
    options,
    title,
    type: 'danger'
  });
}